import {APIENDPOINT} from '../constants';
var APIURL = window.bookingsUrl + APIENDPOINT;
var AUTH = window.AUTH;
export default {
  init() {
    $.ajax({
      url: APIURL + 'room_for_30_min?_format=json',
      method: 'GET',
      beforeSend: function (req) {
        req.setRequestHeader('Authorization', AUTH);
      },
      success: function (rooms) {
        var $roomsContainer = $('.rooms-container');
        $roomsContainer.html();
        rooms.forEach(function (room) {
          $roomsContainer.append(renderRoom(room));
        });
      }, error: function (error) {
        console.log(error);
      }
    });

    $('body').on('click', '.select-room', function () {
      renderSingleRoom($(this).data('roomid'));
      $('.room-name').text($(this).data('name'));
      setActiveStep(1);

    });
    $('body').on('click', '.reset', function () {
      setActiveStep(0);
    });


    $('body').on('click', '.timeslot-button', function(){
      var $button = $(this);
      if($button.hasClass('disabled')){
        return;
      }
      var from = $button.data('from');
      var to = $button.data('to');
      var key  = $button.data('key');
      var id = $button.data('roomid');

      $.ajax({
        url: APIURL + 'room_for_30_min?_format=json',
        method: 'POST',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
          req.setRequestHeader('Content-Type', 'application/json');
        },
        dataType: "json",
        data: JSON.stringify({
          field_room_30_min: id,
          field_timeslots: key
        }),
        success: function (response) {
          $('.date-span').text(from + ' - ' + to);
          setActiveStep(2);
        }, error: function(error){
          console.log("error", error);
        }
      });

    });

    function renderRoom (room) {
      var room = `
      <div class="w-full md:w-1/2 py-2 md:px-2 md:text-left text-center flex">
				<div class="p-6 bg-white rounded-lg flex w-full flex-col justify-start">
					<h3 class="text-2xl md:text-4xl text-secondary-dark">${room.title}</h3>
					<p class="text-black text-sm md:text-lg mt-2 leading-tight md:leading-normal">${room.description}</p>
					<a class="inline-flex no-underline mt-auto" href="#${room.id}">
						<button data-name="${room.title}" data-roomid="${room.id}" class="select-room mx-auto md:mx-0 px-10 mt-6 uppercase cta no-underline text-lg bg-secondary-light text-secondary-dark rounded-full">BOOK THIS ROOM</button>
					</a>
				</div>
			</div>
      `;
      return room;
    }

    function renderSingleRoom (roomid) {
      var $roomContent = $('.single-room-content');
      $roomContent.html('');
      $.ajax({
        url: APIURL + 'room_30_min_booking/' + roomid + '?_format=json',
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
        success: function (slots) {
          var timeslots = '';
          slots.forEach(function (slot) {
            timeslots +=
            `
<button data-roomid="${roomid}" data-key="${slot.slotId}" data-from="${slot.startTime}" data-to="${slot.endTime}" class="timeslot-button rounded-full text-center w-20 justify-center bg-secondary-light h-12 inline-flex text-md text-secondary-dark mx-1 md:mx-0 mt-2 md:mt-1 md:ml-1 ${slot.open ? '' : 'disabled'}">${slot.startTime}</button>
            `;
          });

          for(var filler = 0; filler<5; filler++){
            timeslots +=
            `
<div class="w-20 mx-1 md:hidden" style="height:0px;">&nbsp;</div>
`;
          }

          var singeroom =
          `
          <div class="w-full bg-white rounded-lg p-6 flex flex-col">

            <p class="font-bold alschlange mb-4 text-center md:text-left text-base md:text-xl text-black">Choose a start time</p>
            <div class="text-left flex justify-center md:justify-start flex-wrap">
              ${timeslots}
            </div>

          </div>
          `;

          $roomContent.html(singeroom);
        }, error: function (error) {
          console.log("error", error);
        }
      });
    }

    function setActiveStep (step) {
      var $first = $('.rooms-container');
      var $single = $('.single-room');
      var $final = $('.final-view');

      switch (step) {
        case 0:
          $first.addClass('flex').removeClass('hidden');
          $single.addClass('hidden').removeClass('flex');
          $final.addClass('hidden').removeClass('flex');
          break;
        case 1:
          $first.addClass('hidden').removeClass('flex');
          $single.addClass('flex').removeClass('hidden');
          $final.addClass('hidden').removeClass('flex');
          break;
        case 2:
          $first.addClass('hidden').removeClass('flex');
          $single.addClass('hidden').removeClass('flex');
          $final.addClass('flex').removeClass('hidden');
          break;
      }
    }
  }
};
